import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Contact from "../Contact/Contact.js";
import "./style.css";



export default function DetailWork() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Add an empty dependency array to run the effect only once

  const navigate = useNavigate()

  const handleClick = () => {
    navigate("/")
  }

  return (
    <>
      <nav onClick={handleClick} className='singleWork'>
        <p>Back</p>
      </nav>
      <div className="untree_co-section untree_co-section-4 pb-0" id="portfolio-section">
          <div className="container">
            <div className="portfolio-single-wrap unslate_co--section" id="portfolio-single-section">
              <div className="portfolio-single-inner">
                <h2 className="heading-portfolio-single-h2  mt-5" style={{color:"#063dcc"}}>SIMPLY HOME</h2>

                <div className="row justify-content-between mb-5">
                  <div className="col-12 mb-4">
                    <div className="owl-carousel single-slider">
                    </div>
                  </div>
                  <div className="col-12 my-5">
                    <div className="row">
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Project Date</h4>
                          <span className="detail-val" style={{color:"#063dcc"}}>Aug - 2023</span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Role</h4>
                          <span className="detail-val">
                            <span style={{color:"#063dcc"}}>Design</span>
                          </span>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Code</h4>
                          <a style={{color:"#063dcc"}} href="https://github.com/ASFER8384/Ecom_fr.git" target="_blank" className="detail-val">Live Github</a>
                        </div>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3">
                        <div className="detail-v1">
                          <h4 className="detail-label" style={{color:"#063dcc"}}>Website</h4>
                          <span className="detail-val">
                            <a style={{color:"#063dcc"}} href="https://simply-home.onrender.com/" target="_blank">Live Site</a>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    Step into our e-commerce world, a virtual marketplace where all your shopping desires come to life. From fashion to electronics, home decor to gadgets, we offer a diverse array of products. Our user-friendly interface and secure payment options ensure a smooth and safe shopping experience. Stay updated with the latest trends, score amazing deals, and relish the convenience of doorstep delivery. Browse various categories, and shop with confidence. Your satisfaction is our priority, making online shopping a delightful journey. Join us today, and redefine your shopping experience.
                    </p>
                  </div>
                  <div className="col-md-6">
                    <p style={{color:"#063dcc"}}>
                    At our e-commerce hub, we're redefining the way you shop. Discover a vast range of products, from fashion essentials to cutting-edge electronics, all conveniently available at your fingertips. Our intuitive platform guarantees a secure and seamless shopping experience. Explore the freshest trends, snag unbeatable deals, and relish the convenience of home delivery. With a plethora of categories to explore, your shopping journey is bound to be exciting and worry-free. Join us today, and let's revolutionize the way you shop online.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <Contact />
    </>
  );
}
